module.exports = __webpack_public_path__ + "img/img4.d0f690ae.png";